/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// Misc imports
import { logoutUser } from '../store/auth/authActions';
import { disconnectLivechatSocket } from '../store/liveChat/liveChatThunks';
import { disconnectPushNotifications } from '../store/notifications/notificationsThunks';

const LogoutScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // On mount
  useEffect(() => {
    dispatch(disconnectLivechatSocket());
    dispatch(disconnectPushNotifications());
    dispatch(logoutUser(navigate));
  }, []);

  return null;
};

export default LogoutScreen;
